import React from "react";
import { HeaderContainer } from "./styles";
const Header = () => {
  return (
    <HeaderContainer>
      <div className="solicitacaocaseNumber">
        <span>Protocolo:</span>
      </div>
      <div className="solicitacaoclassificacao">
        <span>Classificação:</span>
      </div>
      <div className="solicitacaodataAbertura">
        <span>Abertura:</span>
      </div>
      <div className="solicitacaoagendamento">
        <span>Agendamento:</span>
      </div>
      <div className="solicitacaoativo">
        <span>Imóvel:</span>
      </div>
      <div className="solicitacaostatus">
        <span>Status:</span>
      </div>
    </HeaderContainer>
  );
};

export default Header;
